import React from 'react';

export default function NewsroomInside({ title, articles }) {
  return (
    <div className="inside-campaign-container">
      <div className="row">
        <h4 className="bold">{title}</h4>
      </div>
      <div className="row">
        <ul>
          {articles.map((article, index) => (
            <li key={index}>
              <a target="_blank" href={article.url} rel="noopener noreferrer">
                {article.title}
              </a>
              <div className="author-info">
                {article.authorInfo}
              </div>
              {article.imageUrl && (
                <div className="newsroom-image">
                  <a target="_blank" href={article.url} rel="noopener noreferrer">
                    <img src={article.imageUrl} alt="" />
                  </a>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
